class demoRegister {

    static campaigns = [];

    static setCampaign(campaign){
        let storage = demoRegister.getCampaigns();
        storage.unshift(campaign);
        try {
            sessionStorage.setItem('campaigns', JSON.stringify(storage));
        }catch (e) {
            demoRegister.campaigns = storage;
        }
    }

    static getCampaigns(){
        if(demoRegister.campaigns.length > 0){
            return demoRegister.campaigns;
        }else{
            let storage = [];
            try {
                storage = JSON.parse(sessionStorage.getItem('campaigns'));
            }catch (e) {
                storage = demoRegister.campaigns;
            }
            if(storage){
                return storage;
            }else{
                return [];
            }
        }
    }

    static removeCampaigns(){
        demoRegister.campaigns = [];
        try {
            sessionStorage.removeItem('campaigns');
        }catch (e) {}
    }

    //SHORTENER
    static set(campaign){
        demoRegister.setCampaign(campaign);
    }

    static get(){
        return demoRegister.getCampaigns();
    }

    static remove(){
        demoRegister.removeCampaigns();
    }

}

export {demoRegister}


// WEBPACK FOOTER //
// ./src/services/demoRegister.js